import OmniApiClient from "./base";

export const wholesaleOrdersApi = {
  summary: () => OmniApiClient.get("/wholesale-orders/summary"),
  list: (params = {}) => OmniApiClient.get("/wholesale-orders", { params }),
  get: (id) => OmniApiClient.get(`/wholesale-orders/${id}`),
  create: (payload) => OmniApiClient.post("/wholesale-orders", payload),
  update: (id, payload) =>
    OmniApiClient.put(`/wholesale-orders/${id}`, payload),
  remove: (id) => OmniApiClient.delete(`/wholesale-orders/${id}`),
  addPayment: (id, payload) =>
    OmniApiClient.post(`/wholesale-orders/${id}/payments`, payload),
  updatePayment: (orderId, paymentId, payload) =>
    OmniApiClient.put(
      `/wholesale-orders/${orderId}/payments/${paymentId}`,
      payload,
    ),
  removePayment: (orderId, paymentId) =>
    OmniApiClient.delete(`/wholesale-orders/${orderId}/payments/${paymentId}`),
  addItem: (id, payload) =>
    OmniApiClient.post(`/wholesale-orders/${id}/items`, payload),
  updateItem: (orderId, itemId, payload) =>
    OmniApiClient.put(`/wholesale-orders/${orderId}/items/${itemId}`, payload),
  removeItem: (orderId, itemId) =>
    OmniApiClient.delete(`/wholesale-orders/${orderId}/items/${itemId}`),
  markItemDelivered: (orderId, itemId) =>
    OmniApiClient.post(
      `/wholesale-orders/${orderId}/items/${itemId}/delivered`,
    ),
  markReady: (id) => OmniApiClient.post(`/wholesale-orders/${id}/mark-ready`),
  downloadInvoiceFile: (id) =>
    OmniApiClient.get(`/wholesale-orders/${id}/invoice-file`, {
      responseType: "blob",
    }),
  parseFile: (file, wholesalerName, wholesalerId) => {
    const form = new FormData();
    form.append("file", file);
    form.append("wholesaler_name", wholesalerName);
    if (wholesalerId != null) {
      form.append("wholesaler_id", String(wholesalerId));
    }
    return OmniApiClient.post("/wholesale-orders/parse-file", form, {
      headers: { "Content-Type": undefined },
      timeout: 130000,
    });
  },
  getSettings: () => OmniApiClient.get("/wholesale-orders/settings"),
  updateSettings: (payload) =>
    OmniApiClient.put("/wholesale-orders/settings", payload),
  generateToken: () =>
    OmniApiClient.post("/wholesale-orders/settings/generate-token"),
  testSettings: (payload) =>
    OmniApiClient.post("/wholesale-orders/settings/test", payload),
};
